import { Component, inject, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LicenseStorage } from '@portal-core/license-storage/models/license-storage.model';
import { LicenseStorageService } from '@portal-core/license-storage/services/license-storage.service';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { LicenseContactSalesDialogComponent, LicenseContactSalesDialogData } from '@portal-core/licenses/components/license-contact-sales-dialog/license-contact-sales-dialog.component';
import { LicenseType } from '@portal-core/licenses/enums/license-type.enum';
import { License } from '@portal-core/licenses/models/license.model';
import { AutoUnsubscribe } from '@portal-core/util/auto-unsubscribe.decorator';
import { Observable } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatButton } from '@angular/material/button';
import { FileSizePipe } from '@portal-core/general/pipes/file-size/file-size.pipe';

@Component({
    selector: 'mc-license-subscription',
    templateUrl: './license-subscription.component.html',
    styleUrls: ['./license-subscription.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, MatProgressBar, MatButton, AsyncPipe, FileSizePipe]
})
@AutoUnsubscribe()
export class LicenseSubscriptionComponent implements OnChanges {
  private readonly licenseStorageService = inject(LicenseStorageService);
  private readonly dialog = inject(MatDialog);

  @Input() license: License;
  @Input() licenseUser: LicenseUser;

  licenseStorage$: Observable<LicenseStorage>;
  get isTrial(): boolean {
    return this.license?.LicenseType === LicenseType.Trial;
  }

  // wait for license to be loaded
  ngOnChanges(changes: SimpleChanges) {
    if (changes.license) {
      if (this.license) {
        // create an observable for the license storage
        this.licenseStorage$ = this.licenseStorageService.getItemById$(this.license.Id, { forceApiRequest: true });
      }
      else {
        this.licenseStorage$ = null;
      }
    }
  }

  openContactSalesDialog() {
    this.dialog.open<LicenseContactSalesDialogComponent, LicenseContactSalesDialogData, void>(LicenseContactSalesDialogComponent, {
      ...LicenseContactSalesDialogComponent.DialogConfig,
      data: {
        license: this.license,
        licenseUser: this.licenseUser
      }
    });
  }
}
